import { FC, useMemo } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps, Space } from 'antd';
import { AlertListTableItem, CompAlertStatus } from '@/api';
import { useTranslation } from 'react-i18next';

import styles from './TableActions.module.sass';

interface TableActionsProps {
  record: AlertListTableItem;
  onStatusChange: (id: string, status: CompAlertStatus) => void;
}

const TableActions: FC<TableActionsProps> = ({ record, onStatusChange }) => {
  const { t } = useTranslation();
  const onItemConfirm = () => onStatusChange(record.id, 'confirmed');
  const onItemReject = () => onStatusChange(record.id, 'rejected');

  const menuItems: MenuProps['items'] = useMemo(() => {
    return [
      {
        key: 'onConfirm',
        label: (
          <button type="button" onClick={onItemConfirm}>
            {t('translation.btn_confirm')}
          </button>
        ),
      },
      {
        key: 'onReject',
        label: (
          <button type="button" onClick={onItemReject}>
            {t('translation.btn_reject')}
          </button>
        ),
      },
    ];
  }, []);

  if (record.state !== 'new') {
    return null;
  }

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="top"
      arrow={{ pointAtCenter: true }}
    >
      <Space>
        <MoreOutlined
          rotate={90}
          className={`${styles.icon} ${styles.icon_action}`}
        />
      </Space>
    </Dropdown>
  );
};

export default TableActions;
